import { SectionCard, SectionCardStickyHeader, SectionCardTitle } from '@plato/ui/containers/section-card';
import { Spinner } from '@plato/ui/primitives/spinner';
import { Typography } from '@plato/ui/primitives/typography';
import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type FeedSectionProps = {
    /** Missing when the page itself already says what the section holds. */
    title?: string;
    isLoading: boolean;
    isEmpty: boolean;
    /** Sits after the day list rather than in it, so the last day still counts as last. */
    footer?: ReactNode;
    children: ReactNode;
};

/** One of a feed's section cards; it stays on the page when there is nothing to list. */
export function FeedSection({ title, isLoading, isEmpty, footer, children }: FeedSectionProps): ReactElement {
    const { t } = useTranslation('activity-feed');

    return (
        <SectionCard>
            {title && (
                <SectionCardStickyHeader>
                    <SectionCardTitle>{title}</SectionCardTitle>
                </SectionCardStickyHeader>
            )}
            {isEmpty && !isLoading ? (
                <Typography variant="body" className="text-content-weaker">
                    {t('feed__empty')}
                </Typography>
            ) : (
                <div>
                    <div className="flex flex-col">{children}</div>
                    {footer}
                </div>
            )}
            {isLoading && <Spinner className="self-center" />}
        </SectionCard>
    );
}
